<p-toast position="top-center" [autoZIndex]="true"></p-toast>
<div class="mt-5 pt-5 become-box-area pb-30">
    <div class="container-fluid">
        <div class="row new-comers-content become-box-content justify-content-center">
            <div class="col-12 text-center">
                <h3>Rejoignez-nous !</h3>
                <h4 class="dash"></h4>
            </div>
        </div>
        <div class="row justify-content-center mt-5">
            <div class="box-inter col-lg-3 col-md-4 col-sm-12 mr-2 mr-lg-3">
                <div class="become-box-item">
                    <div class="row align-items-center">
                        <div class="col-12 partnaire-pic" style="background-image: url(../../../../assets/images/new/intervenants/mark-group1.svg);"></div>
                        <div class="col-12">
                            <div class="become-box-content">
                                <h3>Devenez partenaire</h3>
                                <p>Faites partie du changement, engagez-vous à nos côtés pour offrir aux générations futures les clés de leur réussite !</p>
                                <div class="btn-box">
                                    <!-- <a routerLink="/coming-soon" class="default-btn"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">Commencez</span><i class="bx bx-move-horizontal icon-arrow after"></i></a> -->
                                    <a href="https://workspace.cacebenin.bj/out/authentication/register" target="_blank" class="default-btn"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">Commencez</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-inter col-lg-3 col-md-4 col-sm-12 mr-2 mr-lg-3">
                <div class="become-box-item with-gradient-color mb-30">
                    <div class="row align-items-center">
                        <div class="col-12 partnaire-pic" style="background-image: url(../../../../assets/images/new/intervenants/mark-group2.svg);"></div>
                        <div class="col-12">
                            <div class="become-box-content">
                                <h3>Devenez acteur éducatif</h3>
                                <p>Unissons nos forces, partageons nos savoirs et relevons ensemble les défis éducatifs de notre époque.</p>
                                <div class="btn-box">
                                    <!-- <a routerLink="/coming-soon" class="default-btn"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">S'inscrire</span><i class="bx bx-move-horizontal icon-arrow after"></i></a> -->
                                    <a href="https://workspace.cacebenin.bj/out/authentication/register" class="default-btn"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">S'inscrire</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-inter col-lg-3 col-md-4 col-sm-12 mr-2 mr-lg-3">
                <div class="become-box-item with-gradient-color2 mb-30">
                    <div class="row align-items-center">
                        <div class="col-12 partnaire-pic" style="background-image: url(../../../../assets/images/new/intervenants/mark-group3.svg);"></div>
                        <div class="col-12">
                            <div class="become-box-content">
                                <h3>Besoin d'un encadrant ?</h3>
                                <p>Investissez dans un encadrement de qualité pour des résultats durables ! Garantissez à votre enfant la réussite.</p>
                                <div class="btn-box">
                                    <a (click)="show()" class="default-btn cursor"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">Faire une demande</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                                    <!-- <a class="default-btn cursor"><i class='bx bx-move-horizontal icon-arrow before'></i><span class="label">Contactez nous</span><i class="bx bx-move-horizontal icon-arrow after"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>